module.exports = __webpack_public_path__ + "img/lucy-stone.1cf62c38.png";